import { useEffect} from 'react';
import NoticeList from 'components/board/noticeList';

import PageTab from "components/common/pageTab";
import TopImage from 'components/common/topImage';

import 'assets/css/notice.scss';
import ImgUrl from 'assets/images/board.png';
import {pageMenuTabList06} from 'types/common';

const Notice = () => {
  
  pageMenuTabList06[0].on = true;

  useEffect(() => {
    
  }, [])

  return (
    <div className="page_content">
      <TopImage imgUrl="https://img.chunhomall.com/images/brand_site/notice-hero_1920x1080.jpg.jpg" imgText="회사소식" textcolor="#FFF"></TopImage>
      <PageTab props={pageMenuTabList06}></PageTab>
      <div className="container">

        <div className="container-title">
          천호엔케어 소식을 전합니다.
        </div>

      </div>
      <NoticeList intType={0} />
    </div>
  );
}
  
export default Notice;